import React from 'react';
import { FadeIn } from './Shared';
export function Timeline() {
  return <section className="py-24 px-4 bg-[#0a0a0a] relative border-t border-neutral-900" data-id="element-188">
      <div className="max-w-4xl mx-auto" data-id="element-189">
        <FadeIn data-id="element-190">
          <div className="text-center mb-16" data-id="element-191">
            <h2 className="text-4xl md:text-5xl font-black uppercase mb-6" data-id="element-192">
              The 21-Day <span className="text-toxic" data-id="element-193">Transformation</span>
            </h2>
          </div>
        </FadeIn>

        <div className="relative border-l-2 border-neutral-800 ml-4 md:ml-0 md:border-none" data-id="element-194">
          {/* Desktop horizontal line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-neutral-800 -translate-y-1/2" data-id="element-195" />

          <div className="grid md:grid-cols-3 gap-12 md:gap-8" data-id="element-196">
            <FadeIn delay={0.1} data-id="element-197">
              <div className="relative pl-8 md:pl-0 md:text-center" data-id="element-198">
                {/* Mobile dot */}
                <div className="md:hidden absolute left-[-9px] top-2 w-4 h-4 rounded-full bg-neutral-800 border-2 border-[#0a0a0a]" data-id="element-199" />
                {/* Desktop dot */}
                <div className="hidden md:block absolute left-1/2 top-1/2 w-4 h-4 rounded-full bg-neutral-800 -translate-x-1/2 -translate-y-1/2 z-10" data-id="element-200" />

                <div className="md:mb-16" data-id="element-201">
                  <div className="text-toxic font-black text-2xl mb-2" data-id="element-202">
                    Day 7
                  </div>
                  <h3 className="text-white font-bold mb-3" data-id="element-203">The Lift</h3>
                  <p className="text-neutral-400 text-sm leading-relaxed" data-id="element-204">
                    The "morning heaviness" in your lungs begins to lift.
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-205">
              <div className="relative pl-8 md:pl-0 md:text-center" data-id="element-206">
                {/* Mobile dot */}
                <div className="md:hidden absolute left-[-9px] top-2 w-4 h-4 rounded-full bg-neutral-800 border-2 border-[#0a0a0a]" data-id="element-207" />
                {/* Desktop dot */}
                <div className="hidden md:block absolute left-1/2 top-1/2 w-4 h-4 rounded-full bg-toxic shadow-toxic-glow -translate-x-1/2 -translate-y-1/2 z-10" data-id="element-208" />

                <div className="md:mt-16" data-id="element-209">
                  <div className="text-toxic font-black text-2xl mb-2" data-id="element-210">
                    Day 14
                  </div>
                  <h3 className="text-white font-bold mb-3" data-id="element-211">The Drop</h3>
                  <p className="text-neutral-400 text-sm leading-relaxed" data-id="element-212">
                    Your "Reach Rate" (how often you grab the device) will drop
                    by 60%.
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-213">
              <div className="relative pl-8 md:pl-0 md:text-center" data-id="element-214">
                {/* Mobile dot */}
                <div className="md:hidden absolute left-[-9px] top-2 w-4 h-4 rounded-full bg-neutral-800 border-2 border-[#0a0a0a]" data-id="element-215" />
                {/* Desktop dot */}
                <div className="hidden md:block absolute left-1/2 top-1/2 w-4 h-4 rounded-full bg-white -translate-x-1/2 -translate-y-1/2 z-10" data-id="element-216" />

                <div className="md:mb-16" data-id="element-217">
                  <div className="text-white font-black text-2xl mb-2" data-id="element-218">
                    Day 21
                  </div>
                  <h3 className="text-white font-bold mb-3" data-id="element-219">The Freedom</h3>
                  <p className="text-neutral-400 text-sm leading-relaxed" data-id="element-220">
                    The chemical hook is gone, leaving only a habit that you now
                    have the tools to delete.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}